// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__71IkF","row":"styles_row__R8g8I"};